import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'app/auth/service';
import { DataService } from 'app/auth/service/data.service';
import { ToastrService, } from 'ngx-toastr'
import * as XLSX from 'xlsx'

@Component({
  selector: 'app-export-assignments',
  templateUrl: './export-assignments.component.html',
  styleUrls: ['./export-assignments.component.scss']
})
export class ExportAssignmentsComponent {
  public contentHeader: object;
  filename = "export-data.xlsx";

  currentUser: any;
  assignmentData: any;
  loadingSite: boolean = false;
  community_id: any;

  constructor(
    private _authenticationService: AuthenticationService,
    private dataService: DataService,
    private location: Location,
    private toaster:ToastrService,
    private route: ActivatedRoute
  ) {
    this._authenticationService.currentUser.subscribe
      (x => {
        this.currentUser = x;
      });

      this.route.queryParams.subscribe(params => {
        this.community_id = params['id']
    console.log(params['id']); // use it as needed
  });
      console.log(this.currentUser);
      
  }

  ngOnInit(): void {
    this.contentHeader = {
      headerTitle: 'Shifts',
      actionButton: false,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Home',
            isLink: true,
            link: '/'
          },
          {
            name: 'Shifts',
            isLink: true,
            link: '/shift'
          },
        ]
      }
    };
    this.createAssignmentReport();
  }

  createAssignmentReport() {
    this.loadingSite = true
    this.dataService.createAssignmentReport(this.currentUser.user_role == 3 || this.currentUser.user_role == 6 || this.currentUser.user_role == 8 ? this.community_id :this.currentUser.user_role == 4 ? this.currentUser.com_id :this.currentUser.id).subscribe((res: any) => {
      if(res.error == false){
        this.assignmentData = res.body;
        this.loadingSite = false
      }else{
        this.loadingSite= false
        this.toaster.error(res.msg)
      }
    });
  }

  goBack(){
this.location.back();
  }

}
